import { firstLetterUppercase } from '@openx/utils/lib/firstLetterUppercase.ts';
import { ACTIVE_STATUSES, FAILED_STATUSES, FORBIDDEN_STATUSES } from '../constants.ts';

export type AudienceComputedStatus = 'active' | 'error' | 'warning' | 'inactive';

export const mapStatus = (
  gqlStatus?: string
): {
  label: string;
  status: AudienceComputedStatus;
} | null => {
  if (gqlStatus) {
    const label = gqlStatus
      .split('_')
      .map(value => firstLetterUppercase(value))
      .join(' ');

    // I categorize all AudienceStatus into 4 categories with each mapped to one StatusIndicator status
    if ((ACTIVE_STATUSES as readonly string[]).includes(gqlStatus)) {
      return {
        label,
        status: 'active',
      };
    }

    if ((FAILED_STATUSES as readonly string[]).includes(gqlStatus)) {
      return {
        label,
        status: 'error',
      };
    }

    if ((FORBIDDEN_STATUSES as readonly string[]).includes(gqlStatus)) {
      return {
        label,
        status: 'warning',
      };
    }

    return {
      label,
      status: 'inactive',
    };
  }

  return null;
};
